import { Component, OnInit, ViewContainerRef } from "@angular/core";

/**
 * Dashboard main page component. It's empty for now
 */
@Component({
    selector: "client-onboarding-game-plan",
    templateUrl: "./client-onboarding-game-plan.component.html",
    styleUrls: ["./client-onboarding-game-plan.component.css"],
    standalone: true
})
export class ClientOnboardingGamePlanComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
